var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":_vm.title,"value":true},on:{"close-modal":_vm.closeModal}},[_c('template-form',{attrs:{"role-id":_vm.id,"code-project":_vm.codeProject,"project-id":_vm.projectId,"code-template":_vm.templateCode}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3894e9c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/template/page-template-new.vue
// module id = 1004
// module chunks = 16